import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const ConsumptionIndex = lazy(() => import('./consumption/Index'))

export const LeaveRequestRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--human-resources--leave-request']}>
    <Route path='consumption/*' element={<ConsumptionIndex />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
